const elementScoreHandler = (scoreRecord, scoreString) => {
  const tempKeyValueDistance = 2;
  const scoreStringSearch = searchString => {
    return scoreString.search(new RegExp("\\b" + searchString + "\\b"));
  };
  const scoreStringIndex = (searchString, distance) => {
    return scoreStringSearch(searchString) + searchString.length + distance;
  };

  // Using a word boundary assertion here so the whole word has to match instead of matching to part of a word when searching.
  // Example: if we search for "SSN", search will find the first instance of "SSN" and attempt to use the score from that instance.
  // The first instance of "SSN" could be in "SSNSearchvsNonSearch" which would result in a NaN error. Using the word boundary assertion
  // will ensure that the whole word "SSN" is found and used.
  const calculateScore = searchString => {
    if (scoreStringSearch(searchString) !== -1) {
      let point1 = scoreStringIndex(searchString, tempKeyValueDistance);
      let point2 = scoreString.indexOf(":", point1);
      return scoreString.substring(point1, point2);
    }
    return "";
  };

  scoreRecord.givenName = calculateScore("fn");
  scoreRecord.familyName = calculateScore("ln");
  scoreRecord.addressLine = calculateScore("Street");
  scoreRecord.email = calculateScore("email");
  scoreRecord.phone = calculateScore("phone");
  scoreRecord.coverage = calculateScore("coverage");
  scoreRecord.household = calculateScore("household");
  scoreRecord.gender = calculateScore("gender");
  scoreRecord.mrn = calculateScore("MRN");
  scoreRecord.identifiers = calculateScore("identifiers");
  scoreRecord.studentResourcesId = calculateScore("studentResourcesId");
  scoreRecord.scriptMedPatientId = calculateScore("scriptMedPatientId");
  scoreRecord.rxClaimsSupplementalId = calculateScore("rxClaimsSupplementalId");
  scoreRecord.rxClaimsMemberId = calculateScore("rxClaimsMemberId");
  scoreRecord.riverValleyMemberId = calculateScore("riverValleyMemberId");
  scoreRecord.oxfordMemberId = calculateScore("oxfordMemberId");
  scoreRecord.niceMemberId = calculateScore("niceMemberId");
  scoreRecord.compasMemberNumber = calculateScore("compasMemberNumber");
  scoreRecord.ursulaId = calculateScore("ursulaId");
  scoreRecord.employerAssignedId = calculateScore("employerAssignedId");
  scoreRecord.cdbXrefId = calculateScore("cdbXrefId");
  scoreRecord.irisAccountNumber = calculateScore("irisAccountNumber");
  scoreRecord.altID = calculateScore("altID");
  scoreRecord.hicn = calculateScore("HICNSearchVsNonSearch");
  scoreRecord.mbi = calculateScore("MBISearchVsNonSearch");
  scoreRecord.ssn = calculateScore("SSNSearchVsNonSearch");
  scoreRecord.postalCode = calculateScore("ZipCode");
  scoreRecord.birthDate = calculateScore("DateOfBirth");

  scoreRecord.frequency = {};
  scoreRecord.maxScoreElement = { element: "", maxScore: 0 };
  for (let key in scoreRecord) {
    if (
      key !== "scoreId" &&
      key !== "scoreString" &&
      key !== "recordHrn" &&
      key !== "actions" &&
      key !== "recordNumberInGoldenId" &&
      key !== "frequency" &&
      key !== "maxScoreElement"
    ) {
      const rawElementScoreString = scoreRecord[key];
      if (rawElementScoreString !== "") {
        scoreRecord[key] = rawElementScoreString.includes(":")
          ? parseFloat(rawElementScoreString.split(":")[0]).toFixed(2)
          : parseFloat(rawElementScoreString).toFixed(2);

        if (
          parseFloat(scoreRecord[key]) > scoreRecord.maxScoreElement.maxScore
        ) {
          scoreRecord.maxScoreElement.element = key;
          scoreRecord.maxScoreElement.maxScore = scoreRecord[key];
        }

        const rawElementScoreArray = rawElementScoreString.split(":");
        if (rawElementScoreArray && rawElementScoreArray.length > 1) {
          scoreRecord.frequency[key] = rawElementScoreString
            .split(":")[1]
            .startsWith("-")
            ? rawElementScoreString.split(":")[1].substring(0, 2)
            : rawElementScoreString.split(":")[1].substring(0, 1);
        }
      }
    }
  }

  return scoreRecord;
};

export default elementScoreHandler;
